module.exports = __webpack_public_path__ + "img/product-icon.9b3536f8.svg";